import "./Production.scss";
import MaskedInput from "react-text-mask";
import emailjs from "@emailjs/browser";
import goods from "../../image/goods.image/goods.together/universal-reverse.png"
import React, { useRef, useState } from "react";


export default function Sample() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [email, setEmail] = useState("");
    const [tel, setTel] = useState("");
    const [errors, setErrors] = useState({ email: false, tel: false });
    const form = useRef();

    function validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    function validatePhone(phone) {
        return /^\+38 \(\d{3}\) \d{3} \d{2} \d{2}$/.test(phone);
    }

    const sendEmail = (e) => {
        e.preventDefault();
        let hasError = false;
        let newErrors = { email: false, tel: false };

        if (!email || !validateEmail(email)) {
            newErrors.email = true;
            hasError = true;
        }
        if (!tel || !validatePhone(tel)) {
            newErrors.tel = true;
            hasError = true;
        }

        setErrors(newErrors);
        if (hasError) return;

        setIsSubmitting(true);

        emailjs
            .sendForm(
                "service_dhbzbzd",
                "template_xzb0qfs",
                form.current,
                "54r806kZ5B5Q649la"
            )
            .then(
                () => {
                    alert("Ваше повідомлення відправлено успішно");
                    setEmail("");
                    setTel("");
                    setIsSubmitting(false);
                },
                (error) => {
                    console.log(error.text);
                    setIsSubmitting(false);
                }
            );
    };

    return (
        <div className="sample__container">
            <div className="sample__descr">
                <h1 className="sample__title">Замовити зразок</h1>
                <p className="sample__text">
                    Можна довго розповідати про те, який хороший Агроболік, але ми вважаємо, що краще тисячі слів - це справи. Випробуйте наш препарат без фінансових ризиків.
                </p>
                <div className="sample__inner">
                    <form
                        ref={form}
                        onSubmit={sendEmail}
                        className="sample-form"
                        noValidate
                    >
                        <input
                            className={`sample-form-email${errors.email ? " input-error" : ""}`}
                            type="email"
                            value={email}
                            name="email"
                            placeholder="E-mail"
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setErrors((prev) => ({ ...prev, email: !validateEmail(e.target.value) }));
                            }}
                            onBlur={() => setErrors((prev) => ({ ...prev, email: !validateEmail(email) }))}
                        />
                        <span className="error-text">
                            {errors.email
                                ? (email ? "Введіть коректний e-mail" : "Вкажіть e-mail для звʼязку")
                                : "\u00A0" /* незламний пробіл, щоб завжди було місце */}
                        </span>
                        <MaskedInput
                            mask={[
                                "+", "3", "8", " ", "(", /[0-9]/, /\d/, /\d/, ")",
                                " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/
                            ]}
                            placeholder="Телефон"
                            name="phone"
                            value={tel || ""}
                            onChange={e => {
                                setTel(e.target.value);
                                setErrors((prev) => ({ ...prev, tel: !validatePhone(e.target.value) }));
                            }}
                            onBlur={() => setErrors((prev) => ({ ...prev, tel: !validatePhone(tel) }))}
                            render={(ref, props) => (
                                <input
                                    ref={ref}
                                    {...props}
                                    className={`sample-form-tel${errors.tel ? " input-error" : ""}`}
                                />
                            )}
                        />
                        <span className="error-text">
                            {errors.tel
                                ? (tel ? "Введіть коректний номер телефону" : "Вкажіть номер телефону")
                                : "\u00A0"}
                        </span>
                        <input
                            className="sample-form-submit"
                            type="submit"
                            value="ВІДПРАВИТИ"
                            disabled={isSubmitting}
                        />
                    </form>
                    <div className="sample__bg">
                        <img className="bg__goods" src={goods} alt="goods" />
                    </div>
                </div>
            </div>
        </div>
    );
}
